export default "__VITE_ASSET__C2vc_YAh__"